import { render, staticRenderFns } from "./TodoDetailContact.vue?vue&type=template&id=15abf7cc&scoped=true"
import script from "./TodoDetailContact.vue?vue&type=script&lang=ts"
export * from "./TodoDetailContact.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15abf7cc",
  null
  
)

export default component.exports